var _rect, _g, _path, _path2, _path3, _path4, _path5, _path6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductAvatar5(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 196,
    height: 143,
    viewBox: "0 0 196 143",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.750244,
    y: 0.285645,
    width: 195,
    height: 142,
    rx: 6.85714,
    fill: "#AD91F5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_497_2525)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.361 105.208L69.0068 105.145C65.6964 105.133 63.0191 102.445 63.002 99.1608L63.0117 44.3615C63.0206 41.0549 65.7081 38.3838 68.9966 38.3704L126.351 38.4336C129.661 38.4462 132.338 41.1335 132.356 44.4181L132.346 99.2174C132.337 102.524 129.649 105.195 126.361 105.208Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.0084 104.725L126.359 104.788C126.36 104.788 126.36 104.788 126.36 104.788C129.417 104.775 131.916 102.291 131.925 99.2162L131.934 44.4202C131.934 44.4198 131.934 44.4194 131.934 44.419C131.918 41.3656 129.428 38.8665 126.35 38.8541L69.0084 104.725ZM69.0084 104.725C69.008 104.725 69.0076 104.725 69.0073 104.725C65.9295 104.712 63.4397 102.213 63.4231 99.1599C63.4231 99.1595 63.4231 99.1591 63.4231 99.1587L63.4329 44.3627C63.4329 44.3626 63.4329 44.3625 63.4329 44.3624C63.4413 41.2879 65.9404 38.804 68.9973 38.791C68.9977 38.791 68.998 38.791 68.9984 38.791L126.349 38.8541L69.0084 104.725Z",
    stroke: "#C5C5C5",
    strokeWidth: 0.84173
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M123.2 97.0018L72.7813 96.9661C71.3551 96.9669 70.2165 95.8332 70.2141 94.4087L70.207 49.1195C70.2045 47.695 71.3383 46.5591 72.7645 46.5582L123.184 46.5939C124.61 46.593 125.748 47.7268 125.751 49.1513L125.758 94.4405C125.76 95.865 124.627 97.0009 123.2 97.0018Z",
    fill: "#E4DAFC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7907 64.7627C91.2552 63.5258 91.4371 61.3362 90.1971 59.872C88.9572 58.4079 86.7648 58.2237 85.3003 59.4606C83.8359 60.6975 83.6539 62.8871 84.8939 64.3512C86.1339 65.8153 88.3263 65.9995 89.7907 64.7627Z",
    fill: "#7647EE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M98.8945 79.7913L80.7007 79.7701L85.2484 74.6441L87.5223 72.0811L89.7962 69.5182L92.0708 72.0864L94.3454 74.6547L98.8945 79.7913Z",
    fill: "#FACE8A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M90.7749 70.615L90.2975 70.3362L90.0242 70.5839L89.3904 70.3891L88.8249 70.6127L89.3124 70.0633L89.5561 69.7886L89.7998 69.5139L90.0436 69.7892L90.2873 70.0645L90.7749 70.615Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M114.216 79.8205L87.702 79.7896L94.3295 72.3196L97.6432 68.5846L100.957 64.8496L104.272 68.5923L107.586 72.335L114.216 79.8205Z",
    fill: "#A3DFBC"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M102.382 66.4556L101.686 66.0493L101.288 66.4103L100.364 66.1264L99.5405 66.4522L100.251 65.6516L100.606 65.2513L100.961 64.851L101.316 65.2522L101.672 65.6533L102.382 66.4556Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_497_2525",
    x: 45.212,
    y: 29.4706,
    width: 104.934,
    height: 102.418,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8.89
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8.895
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_497_2525"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_497_2525",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductAvatar5);
export default __webpack_public_path__ + "static/media/productAvatar5.843dc422fdc2f48df57c6929a1b10f64.svg";
export { ForwardRef as ReactComponent };